/* Sol Calypso cart drawer.

   Lifted out of sections/sc-cart.liquid: the section had grown past what can
   be rewritten in one go, and none of this needs Liquid. The three values that
   did come from settings now arrive as data attributes on the root instead. */
(function () {
  var root = document.querySelector('[data-sc-ct]');
  if (!root || root.dataset.bound === '1') return;
  root.dataset.bound = '1';

  var SECTION = root.getAttribute('data-section');
  var OPEN_ON_ADD = root.getAttribute('data-open-on-add') === 'true';
  var MSG_OK = root.getAttribute('data-disc-ok') || 'Discount applied';
  var MSG_BAD = root.getAttribute('data-disc-bad') || 'That code is not valid';
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* A ?skin=vN override for comparing the five styles on the real storefront
     without saving a setting between each look. Liquid writes the real class
     from the section setting; this only repaints it for whoever typed the
     parameter, and the value is pattern-checked rather than trusted, so a
     crafted parameter cannot inject a class of its own. Re-renders keep it,
     because refresh() replaces the drawer's contents but not its root. */
  function currentSkin() {
    var m = /\bsc-ct--(v\d+)\b/.exec(root.className);
    return m ? m[1] : 'v1';
  }

  function setSkin(v) {
    if (!/^v\d+$/.test(v)) return;
    root.className = root.className.replace(/\bsc-ct--v\d+\b/, 'sc-ct--' + v);
  }

  var savedSkin = currentSkin();

  var skinParam = new URLSearchParams(location.search).get('skin');
  if (skinParam && /^v[1-6]$/.test(skinParam)) setSkin(skinParam);

  /* ------------------------------------------------------- design toggle

     Temporary, for comparing the saved style against the Calder one on the
     real storefront. The choice is kept in localStorage because the drawer is
     replaced wholesale on every cart change, which would otherwise snap the
     preview back to the saved style mid-comparison. Nothing here writes a
     setting: it only repaints the class Liquid already rendered. */
  /* Whichever of the two is not the saved one, so the button keeps working
     once the Calder style becomes the default rather than the preview. */
  var ALT = savedSkin === 'v6' ? 'v1' : 'v6';
  var SKIN_KEY = 'sc-ct-skin-preview';

  function readPreview() {
    try { return sessionStorage.getItem(SKIN_KEY); } catch (e) { return null; }
  }

  function applyPreview() {
    var want = readPreview();
    setSkin(want === ALT ? ALT : savedSkin);
    var label = root.querySelector('[data-sc-skin-label]');
    if (label) {
      var base = label.getAttribute('data-base') || label.textContent.trim();
      label.setAttribute('data-base', base);
      label.textContent = base + ' ' + (want === ALT ? '2' : '1');
    }
  }

  if (!skinParam) applyPreview();

  function header() { return document.querySelector('.sc-hd'); }

  /* Read the header's own custom properties so the drawer hangs off it
     correctly whatever inset / bar height is configured there. */
  function syncOffsets() {
    var h = header();
    if (!h) return;
    var cs = getComputedStyle(h);
    var inset = cs.getPropertyValue('--inset').trim() || '16px';
    var ann = cs.getPropertyValue('--ann-h').trim() || '30px';
    var bar = cs.getPropertyValue('--bar-h').trim() || '51px';
    root.style.setProperty('--top', 'calc(' + inset + ' + ' + ann + ' + ' + bar + ')');
    root.style.setProperty('--edge', inset);
  }
  syncOffsets();
  window.addEventListener('resize', syncOffsets);

  /* Mirror the header's own is-cart state onto the drawer, so the header
     keeps owning open/close (and its body-scroll lock) while the drawer
     lives outside it in the DOM. */
  function mirror() {
    var hd = header();
    root.classList.toggle('is-open', !!(hd && hd.classList.contains('is-cart')));
  }
  var hd = header();
  if (hd) new MutationObserver(mirror).observe(hd, { attributes: true, attributeFilter: ['class'] });
  mirror();

  /* The header closes its panels on any document click landing outside
     <sc-header>. The drawer is outside it, so its own clicks must not
     reach that listener. */
  root.addEventListener('click', function (e) { e.stopPropagation(); });

  function open() {
    var h = header();
    if (!h || h.classList.contains('is-cart')) return;
    var btn = h.querySelector('[data-sc-cart]');
    if (btn) btn.click();
  }

  function close() {
    var h = header();
    if (h && h.classList.contains('is-cart')) {
      var btn = h.querySelector('[data-sc-cart]');
      if (btn) btn.click();
    }
  }

  function syncHeaderCount(count) {
    document.querySelectorAll('.sc-hd [data-sc-count]').forEach(function (n) { n.textContent = String(count); });
    document.querySelectorAll('.sc-hd [data-sc-dot]').forEach(function (n) { n.classList.toggle('is-empty', count === 0); });
  }

  var busy = false;

  /* Re-render from the section itself rather than patching values in JS:
     money formatting, discounts, the savings total and the free-shipping
     maths all stay in Liquid, so they cannot drift from what the cart
     actually holds. */
  function refresh(shouldOpen) {
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(SECTION);
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sc-ct]');
        if (!fresh) return;
        root.innerHTML = fresh.innerHTML;
        var count = parseInt(fresh.getAttribute('data-count'), 10);
        root.setAttribute('data-count', String(count));
        root.classList.toggle('is-empty', count === 0);
        syncHeaderCount(isNaN(count) ? 0 : count);
        /* The drawer is replaced wholesale on every mutation, so anything
           driven from JS rather than Liquid has to be put back afterwards. */
        startCountdown();
        paintDelivery();
        applyAddonPage();
        if (!skinParam) applyPreview();
        if (shouldOpen) open();
      })
      .catch(function () {});
  }

  function post(path, body) {
    if (busy) return Promise.resolve();
    busy = true;
    root.setAttribute('aria-busy', 'true');
    return fetch(rootUrl + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) { return refresh(false).then(function () { return res; }); })
      .catch(function () { return { ok: false, data: null }; })
      .then(function (res) {
        busy = false;
        root.removeAttribute('aria-busy');
        return res;
      });
  }

  /* --------------------------------------------------------- changing size

     cart/change.js can only move a line's quantity, never its variant, so a
     size change is a remove and an add.

     The add goes first on purpose. If the new size turns out to be
     unavailable the request fails and the original line is still sitting in
     the cart; removing first would lose it and leave the customer with
     nothing. Only once the add is confirmed is the old line dropped, and the
     drawer re-renders once at the end rather than after each call. */
  function swapVariant(oldKey, newId, qty) {
    if (busy || !oldKey || !newId) return;
    busy = true;
    root.setAttribute('aria-busy', 'true');

    var json = { 'Content-Type': 'application/json', Accept: 'application/json' };

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: json,
      body: JSON.stringify({ items: [{ id: parseInt(newId, 10), quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add rejected');
        /* change.js validates id as a line key or a bare variant id and
           rejects a JSON integer, so the key is passed through as-is. */
        return fetch(rootUrl + 'cart/change.js', {
          method: 'POST',
          headers: json,
          body: JSON.stringify({ id: oldKey, quantity: 0 })
        });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        root.removeAttribute('aria-busy');
        return refresh(false);
      });
  }

  root.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('[data-sc-size]');
    if (!sel) return;

    /* An add-on that is not in the cart yet has no line to swap: its select
       is only the variant the switch will add when it is turned on. */
    var key = sel.getAttribute('data-sc-line-key');
    if (!key) return;

    swapVariant(key, sel.value, parseInt(sel.getAttribute('data-sc-qty-now'), 10) || 1);
  });

  /* ------------------------------------------------------------ delivery

     The same estimate the product page shows, worked out the same way
     (snippets/sc-pd-delivery.liquid): business days only, and past the
     cut-off the clock starts on the next working day. The two used to be
     calculated differently and told the same customer two different dates.

     Only the arrival window is shown here, as "Thu, Sep 24–Sep 28": the
     weekday once, on the first date, and the second date without it. The
     month stays on both ends so a window that crosses a month still reads
     correctly, which is what trimming the month rather than the weekday
     would have broken. */
  function paintDelivery() {
    var el = root.querySelector('[data-sc-ct-del]');
    if (!el) return;
    var out = el.querySelector('[data-sc-ct-deltext]');
    if (!out) return;

    function n(k) { return parseInt(el.getAttribute('data-' + k), 10) || 0; }

    var lang = document.documentElement.lang || undefined;
    var full, short;
    try {
      full = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short' });
      short = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' });
    } catch (e) {
      full = short = { format: function (d) { return d.toDateString(); } };
    }

    function isWeekend(d) { var w = d.getDay(); return w === 0 || w === 6; }
    function roll(d) { var x = new Date(d.getTime()); while (isWeekend(x)) x.setDate(x.getDate() + 1); return x; }
    function addWork(from, days) {
      var d = new Date(from.getTime()), left = days;
      while (left > 0) { d.setDate(d.getDate() + 1); if (!isWeekend(d)) left--; }
      return roll(d);
    }

    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var ordered = now.getHours() >= n('cutoff') ? addWork(today, 1) : roll(today);
    var getA = addWork(addWork(ordered, n('pmin')), n('tmin'));
    var getB = addWork(addWork(ordered, n('pmax')), n('tmax'));

    var window_ = getA.getTime() === getB.getTime()
      ? full.format(getA)
      : full.format(getA) + '\u2013' + short.format(getB);

    var tpl = el.getAttribute('data-text') || 'Arrives [dates]';
    out.textContent = tpl.indexOf('[dates]') > -1 ? tpl.replace('[dates]', window_) : tpl + ' ' + window_;
  }

  paintDelivery();

  /* ---------------------------------------------------------------- countdown

     A reservation timer is only honest if it survives a re-render, and the
     drawer re-renders on every quantity change. The deadline therefore lives
     in sessionStorage, not in a variable: the same cart keeps counting down
     to the same moment however many times the markup is replaced.

     It starts on the first render with something in the cart and is cleared
     when the cart empties, so an abandoned-then-refilled cart gets a fresh
     window rather than one that expired while nobody was looking. */
  var KEY = 'sc-ct-deadline';
  var tick = null;

  function clearCountdown() {
    if (tick) { clearInterval(tick); tick = null; }
    try { sessionStorage.removeItem(KEY); } catch (e) {}
  }

  function startCountdown() {
    if (tick) { clearInterval(tick); tick = null; }

    var el = root.querySelector('[data-sc-countdown]');
    if (!el) return;

    var count = parseInt(root.getAttribute('data-count'), 10);
    if (!count) { clearCountdown(); return; }

    var minutes = parseFloat(el.getAttribute('data-minutes')) || 10;
    var deadline = 0;
    try { deadline = parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) {}

    if (!deadline || deadline < Date.now()) {
      deadline = Date.now() + minutes * 60000;
      try { sessionStorage.setItem(KEY, String(deadline)); } catch (e) {}
    }

    function paint() {
      var left = Math.max(0, deadline - Date.now());
      var total = Math.round(left / 1000);
      var mm = Math.floor(total / 60);
      var ss = total % 60;
      el.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
      if (left <= 0) {
        clearInterval(tick);
        tick = null;
        var wrap = el.closest('[data-sc-countdown-wrap]');
        if (wrap) wrap.classList.add('is-done');
      }
    }

    paint();
    tick = setInterval(paint, 1000);
  }

  startCountdown();

  /* ----------------------------------------------------------- add-on pages

     Every page of add-ons is in the DOM already; paging only changes which is
     shown. That matters because each switch's state is rendered from the cart,
     so a product added on page one is still in the cart -- and still shown as
     on -- after paging away and back.

     The index lives out here rather than in the markup so it survives the
     re-render that every cart change triggers: toggling a switch on page two
     leaves you on page two instead of snapping back to the first. */
  var addonPage = 0;

  function applyAddonPage() {
    var rows = root.querySelectorAll('.sc-ct__addon[data-page]');
    if (!rows.length) return;

    var pages = 0;
    rows.forEach(function (r) {
      pages = Math.max(pages, (parseInt(r.getAttribute('data-page'), 10) || 0) + 1);
    });

    /* The collection can shrink between renders, so wrap rather than trusting
       the stored index to still exist. */
    if (addonPage >= pages) addonPage = 0;
    if (addonPage < 0) addonPage = pages - 1;

    rows.forEach(function (r) {
      r.hidden = (parseInt(r.getAttribute('data-page'), 10) || 0) !== addonPage;
    });

    var label = root.querySelector('[data-sc-addon-page]');
    if (label) label.textContent = (addonPage + 1) + '/' + pages;
  }

  applyAddonPage();

  /* ------------------------------------------------------------ review rail

     Pure presentation, so it is driven from the DOM rather than from state:
     the rail scrolls by exactly one card, whatever the card measures at the
     current drawer width. */
  function railStep(track, dir) {
    var card = track.querySelector('.sc-ct__qcard');
    var gap = parseFloat(getComputedStyle(track).columnGap) || 10;
    var step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('[data-sc-skin]')) {
      e.preventDefault();
      try {
        sessionStorage.setItem(SKIN_KEY, readPreview() === ALT ? savedSkin : ALT);
      } catch (err) {}
      applyPreview();
      return;
    }

    if (t.closest('[data-sc-ct-close]')) { e.preventDefault(); close(); return; }

    var qty = t.closest('[data-sc-qty]');
    if (qty) {
      e.preventDefault();
      post('cart/change.js', {
        line: parseInt(qty.getAttribute('data-sc-line-index'), 10),
        quantity: parseInt(qty.getAttribute('data-sc-qty'), 10)
      });
      return;
    }

    var add = t.closest('[data-sc-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('.sc-ct__rec');
      var sel = card && card.querySelector('.sc-ct__recvar');
      var id = sel ? sel.value : add.getAttribute('data-sc-add');
      post('cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] });
      return;
    }

    /* Shipping protection.

       Two endpoints, not one: change.js can only move a line that is already
       in the cart, so switching the cover ON has to go through add.js.

       And the id types differ between them. add.js takes a number; change.js
       validates `id` against /\A\d+\z|\A\d+:[a-f0-9]{32}\z/ and rejects a JSON
       integer outright with a 400, so the raw attribute string is passed
       through untouched. Sending parseInt to both is a silent no-op. */
    var prot = t.closest('[data-sc-prot]');
    if (prot) {
      e.preventDefault();
      var pid = prot.getAttribute('data-sc-prot');
      if (prot.getAttribute('aria-checked') === 'true') {
        post('cart/change.js', { id: pid, quantity: 0 });
      } else {
        post('cart/add.js', { items: [{ id: parseInt(pid, 10), quantity: 1 }] });
      }
      return;
    }

    /* Add-ons. Same two-endpoint dance as protection above, and the same id
       typing rule -- a number for add.js, the raw string for change.js. The
       switch is optimistically flipped before the request so the gesture feels
       answered; the re-render then supplies the truth either way. */
    var addon = t.closest('[data-sc-addon]');
    if (addon) {
      e.preventDefault();
      var aid = addon.getAttribute('data-sc-addon');
      var wasOn = addon.getAttribute('aria-checked') === 'true';
      addon.setAttribute('aria-checked', wasOn ? 'false' : 'true');
      if (wasOn) {
        post('cart/change.js', { id: aid, quantity: 0 });
      } else {
        /* Add the size showing in the row's picker, not whichever variant
           happened to be listed first. */
        var arow = addon.closest('.sc-ct__addon');
        var asel = arow && arow.querySelector('[data-sc-size]');
        post('cart/add.js', { items: [{ id: parseInt(asel ? asel.value : aid, 10), quantity: 1 }] });
      }
      return;
    }

    var apage = t.closest('[data-sc-addon-prev], [data-sc-addon-next]');
    if (apage) {
      e.preventDefault();
      addonPage += apage.hasAttribute('data-sc-addon-next') ? 1 : -1;
      applyAddonPage();
      return;
    }

    var nav = t.closest('[data-sc-rec-prev], [data-sc-rec-next]');
    if (nav) {
      e.preventDefault();
      var track = root.querySelector('[data-sc-rec-track]');
      if (!track) return;
      var card2 = track.querySelector('.sc-ct__rec');
      var step = card2 ? card2.getBoundingClientRect().width + 10 : track.clientWidth;
      track.scrollBy({ left: nav.hasAttribute('data-sc-rec-next') ? step : -step, behavior: 'smooth' });
      return;
    }

    var qnav = t.closest('[data-sc-q-prev], [data-sc-q-next]');
    if (qnav) {
      e.preventDefault();
      var qtrack = root.querySelector('[data-sc-q-track]');
      if (qtrack) railStep(qtrack, qnav.hasAttribute('data-sc-q-next') ? 1 : -1);
      return;
    }

    var apply = t.closest('[data-sc-disc-apply]');
    if (apply) {
      e.preventDefault();
      var input = root.querySelector('[data-sc-disc-input]');
      var code = input ? input.value.trim() : '';
      if (!code) return;
      post('cart/update.js', { discount_codes: [code] }).then(function () {
        var m = root.querySelector('[data-sc-disc-msg]');
        if (!m) return;
        m.hidden = false;
        /* The savings row now shows for a compare-at gap too, so a code being
           accepted is judged on a discount tag appearing, not on the row. */
        var applied = root.querySelector('.sc-ct__savings .sc-ct__tag');
        m.textContent = applied ? MSG_OK : MSG_BAD;
        m.classList.toggle('is-bad', !applied);
      });
      return;
    }
  });

  /* Horizon publishes every cart mutation as a standard storefront event.
     Nothing was listening, which is why the count only caught up on the
     next page load and adding never surfaced the drawer. */
  document.addEventListener('shopify:cart:lines-update', function (event) {
    var isAdd = event.action === 'add';
    Promise.resolve(event.promise)
      .then(function (result) {
        var count = result && result.cart ? result.cart.totalQuantity : null;
        if (typeof count === 'number') syncHeaderCount(count);
        return refresh(isAdd && OPEN_ON_ADD);
      })
      .catch(function () {});
  });
})();
